var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import Vue from 'vue';
import { mapState } from 'vuex';
import headNav from '../../views/header.vue';
import footer from '../../views/footer.vue';
import textarea from '../../components/console-common/common-textarea.vue';
import commonImageUploader from '../../components/console-common/common-image-uploader.vue';
export default Vue.extend({
    name: 'helpCenterFeedback',
    components: {
        'el-head-nav': headNav,
        'el-footer': footer,
        'el-custom-textarea': textarea,
        'common-image-uploader': commonImageUploader,
    },
    computed: __assign({}, mapState('help', {
        faq: 'questionList',
    })),
    data: function () {
        return {
            ruleForm: {
                feedbackType: '',
                content: '',
                contactPhone: '',
                picList: [],
            },
            imageObj: {},
            imageObjConfig: {
                url: '/proxy/help/upload',
                config: {
                    limit: 5,
                    key: 'images',
                    title: '相关图片',
                    isHidePageTitle: true,
                    span: 12,
                    fileList: [],
                },
            },
            rules: {
                feedbackType: [
                    { required: true, message: '请选择反馈类别', trigger: 'change' },
                ],
                content: [
                    { required: true, message: '请输入反馈内容', trigger: 'blur' },
                    {
                        min: 1,
                        max: 500,
                        message: '长度在 1 到 500 个字符',
                        trigger: 'blur',
                    },
                ],
            },
        };
    },
    created: function () {
        this.$store.dispatch('help/GET_QUESTIONLIST', {
            hotFlag: true,
        });
        document.documentElement.scrollTop = 0;
    },
    methods: {
        toQuestions: function (params) {
            this.$router.push({ name: 'helpCenterQuestions', query: params });
        },
        toHelpCenter: function () {
            this.$router.push({ name: 'helpCenter' });
        },
        submitFeedback: function () {
            var _this = this;
            var key = this.$refs.imageUpload.imageObj.key;
            this.imageObj[key] = this.$refs.imageUpload._data.uploadKeys.join(',');
            var picList = this.imageObj.images.split(',');
            picList.length === 1 &&
                picList[0] === '' &&
                picList.splice(picList.length - 1, 1);
            this.ruleForm = Object.assign(this.ruleForm, {
                picList: picList,
            });
            this.$refs['ruleForm'].validate(function (valid) {
                if (!valid) {
                    return;
                }
                var data = _this.ruleForm;
                _this.$request({
                    url: '/proxy/help/help/dfs/feedback/add',
                    method: 'post',
                    data: data,
                }).then(function (res) {
                    if (!res || res.errorCode) {
                        return;
                    }
                    _this.$message({
                        message: '提交成功',
                        type: 'success',
                    });
                });
            });
        },
    },
});
